import {
  withFormsy,
} from 'formsy-react';

import InputPhoneView from './InputPhoneView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputPhoneView);

const Component = InputComponent;

export default Component;
